// import {useEffect, useNavigate} from "react";

export default function CustomerPanel() {
// const navigate = useNavigate();

// }
  // useEffect(() => {
  //   const fetchProfile = async () => {
  //     const token = localStorage.getItem("accessToken");
  //     if (!token) {
  //       navigate("/user-login/");
  //       return;
  //     }
  //   };
  //     fetchProfile();
  //     }, [navigate]);

  return (
      <p>پنل مشتری</p>
  );
};